/* eslint-disable func-names */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { find, cloneDeep, last, isArray, difference, isEmpty } from 'lodash'
import 'react-quill/dist/quill.snow.css'

import {
  getFormattedAttrId,
  reIndexResponses,
} from '@edulastic/common/src/helpers'
import { notification, LanguageContext } from '@edulastic/common'

import produce from 'immer'

import { withNamespaces } from '@edulastic/localization'
import loadable from '@loadable/component'
import Progress from '@edulastic/common/src/components/Progress'

import { LANGUAGE_EN } from '@edulastic/constants/const/languages'
import { questionType } from '@edulastic/constants'
import { updateVariables } from '../../utils/variables'
import { setQuestionDataAction } from '../../../author/QuestionEditor/ducks'

import { Subtitle } from '../../styled/Subtitle'
import Question from '../../components/Question'

import ClearContentConfirmationModal from '../../components/ConfirmClearStimulusModal'
import {
  getCurrentLanguage,
  getLanguageTabsSelector,
} from '../../../common/components/LanguageSelectorTab/duck'
import { getLanguageKeys } from '../../../common/utils/helpers'
import { getCurrentQuestionSelector } from '../../../author/sharedDucks/questions'
import { initializeLanguageObj } from '../../utils/question'
import { INITIAL_FIELD_VALUES_BY_QTYPE } from '../../constants/constantsForQuestions'

const FroalaEditor = loadable(() =>
  import(
    /* webpackChunkName: "froalaCommonChunk" */ '@edulastic/common/src/components/FroalaEditor'
  )
)

const INITIAL_FIELD_VALUES =
  INITIAL_FIELD_VALUES_BY_QTYPE[questionType.CLOZE_DROP_DOWN]
class TemplateMarkup extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    setQuestionData: PropTypes.func.isRequired,
    fillSections: PropTypes.func,
    cleanSections: PropTypes.func,
  }

  constructor(props) {
    super(props)
    this.state = {
      showClearContentModal: false,
      prevItem: {},
    }
  }

  componentWillUnmount() {
    this.setState({
      showClearContentModal: undefined,
      prevItem: undefined,
    })
  }

  static defaultProps = {
    fillSections: () => {},
    cleanSections: () => {},
  }

  toggleShowClearContentModal = () => {
    this.setState((prevState) => ({
      ...prevState,
      showClearContentModal: !prevState.showClearContentModal,
    }))
  }

  setTempContent = (prevItem = {}) => {
    this.setState((prevState) => ({
      ...prevState,
      prevItem: cloneDeep(prevItem),
    }))
  }

  handleModalResponse = (response) => {
    const { setQuestionData, item } = this.props
    const { prevItem } = this.state
    if (response === 'clear') {
      // Reset the stimulus and options
      setQuestionData(
        produce(item, (draft) => {
          draft.stimulus = INITIAL_FIELD_VALUES.stimulus
          draft.responseIds = INITIAL_FIELD_VALUES.responseIds
          draft.options = INITIAL_FIELD_VALUES.options
          draft.validation = INITIAL_FIELD_VALUES.validation
          getLanguageKeys(draft).forEach((lang) => {
            draft.languageFeatures[lang].stimulus =
              INITIAL_FIELD_VALUES.stimulus
            draft.languageFeatures[lang].options = INITIAL_FIELD_VALUES.options
            draft.languageFeatures[lang].validation =
              INITIAL_FIELD_VALUES.validation
          })
          updateVariables(draft)
        }),
        LANGUAGE_EN
      )
      this.toggleShowClearContentModal()
      this.setTempContent()
    } else {
      if (!isEmpty(prevItem)) {
        setQuestionData(prevItem, LANGUAGE_EN)
      }
      this.toggleShowClearContentModal()
      this.setTempContent()
    }
  }

  onChangeMarkUp = (stimulus) => {
    try {
      const { item, setQuestionData } = this.props

      const reduceResponseIds = (tmpl) => {
        const newResponseIds = []
        if (!window.$) {
          return newResponseIds
        }
        const temp = tmpl || ''
        const parsedHTML = $('<div />').html(temp)

        $(parsedHTML)
          .find('textdropdown')
          .each(function (index) {
            const id = $(this).attr('id')
            newResponseIds.push({ index, id })
          })

        return newResponseIds
      }

      const reduceValidation = (responseIds, validation) => {
        const _validation = cloneDeep(validation)
        const _responseIds = cloneDeep(responseIds)
        const validResponses = _validation.validResponse.value

        // remove deleted dropdown answer
        validResponses.map((answer, i) => {
          const { id } = answer
          if (!id) {
            validResponses.splice(i, 1)
          }
          const isExist = find(_responseIds, (response) => response.id === id)
          if (!isExist) {
            validResponses.splice(i, 1)
          }
        })

        // add new correct answers with response id
        _responseIds.map((response) => {
          const { id } = response
          const valid = find(validResponses, (answer) => answer.id === id)
          if (!valid) {
            validResponses.push({ id, value: '' })
          } else {
            valid.index = response.index
          }
        })
        validResponses.sort((a, b) => a.index - b.index)
        _validation.validResponse.value = validResponses

        // reduce alternate answers
        if (isArray(_validation.altResponses)) {
          _validation.altResponses.map((altAnswers) => {
            if (
              _validation.validResponse.value.length > altAnswers.value.length
            ) {
              altAnswers.value.push(last(_validation.validResponse.value))
            }
            altAnswers.value.map((altAnswer, index) => {
              const isExist = find(
                _responseIds,
                (response) => response.id === altAnswer.id
              )
              if (!isExist) {
                altAnswers.value.splice(index, 1)
              }
            })
            altAnswers.value.sort((a, b) => a.index - b.index)
          })
        }

        return _validation
      }

      const reduceOptions = (responseIds, options) => {
        const _options = cloneDeep(options)
        Object.keys(_options).map((id) => {
          const isExist = find(responseIds, (response) => response.id === id)
          if (!isExist) {
            delete _options[id]
          }
        })
        return _options
      }

      const {
        item: { stimulus: prevStimulus = INITIAL_FIELD_VALUES.stimulus },
        questionData,
        currentLanguage,
        languageTabs = [],
      } = this.props

      /**
       * getLanguageKeys is a helper function to get the language keys of the current item
       */
      const languageKeys = getLanguageKeys(item)

      /**
       * when stimulus is empty we need to set the primary language as the first language
       * when stimulus is not empty we need to set the primary language as the English
       */
      const [primaryLanguage] = languageTabs || []

      /**
       * responseIds is the array of response box ids in the current stimulus
       */
      const responseIds = reduceResponseIds(stimulus) || []

      /**
       * prevResponseIds is the array of response box ids in the previous stimulus
       */
      const prevResponseIds = reduceResponseIds(prevStimulus) || []
      /**
       * differenceOfResponseBoxCount is the difference of response box count between the previous stimulus and the current stimulus
       */
      const differenceOfResponseBoxCount =
        prevResponseIds?.length - responseIds?.length

      /**
       * isNewStimulusEmpty is a flag to check if the new stimulus is empty and the previous stimulus is not empty
       * and the difference of response box count is not 0
       */
      const isNewStimulusEmpty =
        differenceOfResponseBoxCount !== 0 &&
        (prevStimulus || '').trim().length &&
        !(stimulus || '').trim().length
      /**
       * when currentLanguage is not the primary language and the difference of response box count is not 0
       * we need to show the clear content modal
       */
      if (
        currentLanguage !== primaryLanguage &&
        differenceOfResponseBoxCount !== 0
      ) {
        /**
         * When stimulus is empty user is trying to remove all content + response boxes
         */
        if (isNewStimulusEmpty) {
          this.toggleShowClearContentModal(true)
          this.setTempContent(questionData)
          /** empty the stimulus for state update, require to update the component */
          setQuestionData(
            produce(questionData, (draft) => {
              draft.stimulus = ''
              languageKeys.forEach((lang) => {
                if (draft.languageFeatures[lang]) {
                  draft.languageFeatures[lang].stimulus = ''
                }
              })
            }),
            LANGUAGE_EN
          )
          return
        }
        /**
         * Here we return because response boxes are changed but stimulus is still present
         * It means user is trying to remove the response in other language tab (not primary),
         * No change FroalaEditor is reverting response box changes
         */
        notification({
          type: 'warn',
          messageKey: 'warnChangeInResponseBoxes',
        })
        return
      }

      /** Removes response boxes */
      if (differenceOfResponseBoxCount > 0) {
        const removedResponseIds = difference(
          prevResponseIds.map((response) => response.id),
          responseIds.map((response) => response.id)
        )
        setQuestionData(
          produce(questionData, (draft) => {
            if (primaryLanguage === LANGUAGE_EN) {
              draft.stimulus = stimulus
              draft.responseIds = responseIds
              draft.options = reduceOptions(draft.responseIds, draft.options)
              draft.validation = reduceValidation(
                draft.responseIds,
                draft.validation
              )
            } else {
              initializeLanguageObj(
                draft,
                primaryLanguage,
                INITIAL_FIELD_VALUES
              )
              draft.languageFeatures[primaryLanguage].stimulus = stimulus
              draft.responseIds = reduceResponseIds(stimulus)
              draft.languageFeatures[primaryLanguage].options = reduceOptions(
                draft.responseIds,
                draft?.languageFeatures?.[primaryLanguage].options
              )
              draft.languageFeatures[
                primaryLanguage
              ].validation = reduceValidation(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage]?.validation
              )
            }
            languageKeys
              .filter((language) => language !== primaryLanguage)
              .forEach((lang) => {
                initializeLanguageObj(draft, lang, INITIAL_FIELD_VALUES)
                const languageStimulus =
                  draft.languageFeatures[lang].stimulus || ''
                const parsedHTML = $('<div />').html(languageStimulus)
                if (languageStimulus) {
                  removedResponseIds.forEach((responseId) => {
                    parsedHTML
                      .find(`textdropdown[key="${responseId}"]`)
                      .remove()
                  })
                }
                draft.languageFeatures[lang].stimulus = reIndexResponses(
                  parsedHTML.html() || ''
                )
                draft.languageFeatures[lang].options = reduceOptions(
                  draft.responseIds,
                  draft.languageFeatures[lang]?.options || []
                )
                draft.languageFeatures[lang].validation = reduceValidation(
                  draft.responseIds,
                  draft.languageFeatures[lang]?.validation || EMPTY_VALIDATION
                )
              })

            updateVariables(draft)
          }),
          LANGUAGE_EN
        )
        return
      }

      /** 2. Adds response boxes */
      if (differenceOfResponseBoxCount < 0) {
        console.log('added response box')
        const newResponses = difference(
          responseIds.map((response) => response.id),
          prevResponseIds.map((response) => response.id)
        )

        setQuestionData(
          produce(questionData, (draft) => {
            if (primaryLanguage === LANGUAGE_EN) {
              draft.stimulus = stimulus
              draft.responseIds = reduceResponseIds(stimulus)
              draft.options = reduceOptions(draft.responseIds, draft.options)
              draft.validation = reduceValidation(
                draft.responseIds,
                draft.validation
              )
            } else {
              initializeLanguageObj(
                draft,
                primaryLanguage,
                INITIAL_FIELD_VALUES
              )

              draft.languageFeatures[primaryLanguage].stimulus = stimulus
              draft.responseIds = responseIds
              draft.languageFeatures[primaryLanguage].options = reduceOptions(
                draft.responseIds,
                draft?.languageFeatures?.[primaryLanguage]?.options || []
              )
              draft.languageFeatures[
                primaryLanguage
              ].validation = reduceValidation(
                draft.responseIds,
                draft.languageFeatures[primaryLanguage].validation
              )
            }
            languageKeys
              .filter((language) => language !== primaryLanguage)
              .forEach((lang) => {
                initializeLanguageObj(draft, lang, INITIAL_FIELD_VALUES)
                let languageStimulus =
                  draft.languageFeatures[lang].stimulus || ''

                let currentIndex = responseIds.length
                newResponses.forEach((responseId) => {
                  languageStimulus += `&nbsp;<textdropdown id="${responseId}" contenteditable="false" key="${responseId}" responseindex=${currentIndex}></textdropdown>&nbsp;`
                  currentIndex++
                })
                draft.languageFeatures[lang].stimulus = languageStimulus
                draft.languageFeatures[lang].options = reduceOptions(
                  draft.responseIds,
                  draft?.languageFeatures?.[lang]?.options || []
                )
                draft.languageFeatures[lang].validation = reduceValidation(
                  draft.responseIds,
                  draft.languageFeatures[lang].validation
                )
              })
            updateVariables(draft)
          }),
          LANGUAGE_EN
        )
        return
      }

      /** 3. No change in response boxes */
      setQuestionData(
        produce(item, (draft) => {
          draft.stimulus = stimulus
          draft.responseIds = responseIds
          draft.validation = reduceValidation(
            draft.responseIds,
            draft.validation
          )
          draft.options = reduceOptions(draft.responseIds, draft.options)
          updateVariables(draft)
        })
      )
    } catch (error) {
      console.error('Error in onChangeMarkUp:', error)
    }
  }

  render() {
    const {
      t,
      item,
      fillSections,
      cleanSections,
      froalaFooter,
      languageTabs = [],
      currentLanguage,
    } = this.props
    const { showClearContentModal } = this.state

    /**
     * when stimulus is empty we need to set the primary language as the first language
     * when stimulus is not empty we need to set the primary language as the English
     */

    return (
      <Question
        section="main"
        label={t('component.cloze.dropDown.composequestion')}
        fillSections={fillSections}
        cleanSections={cleanSections}
      >
        <Subtitle
          id={getFormattedAttrId(
            `${item?.title}-${t('component.cloze.dropDown.composequestion')}`
          )}
        >
          {t('component.cloze.dropDown.composequestion')}
        </Subtitle>
        <LanguageContext.Provider value={{ currentLanguage, languageTabs }}>
          <FroalaEditor
            footer={froalaFooter}
            fallback={<Progress />}
            data-cy="templateBox"
            toolbarId="cloze-dropdown-template-box"
            placeholder={t('component.cloze.dropDown.thisisstem')}
            additionalToolbarOptions={['textdropdown']}
            value={item.stimulus}
            onChange={this.onChangeMarkUp}
            border="border"
          />
        </LanguageContext.Provider>

        <ClearContentConfirmationModal
          handleModalResponse={this.handleModalResponse}
          showClearContentModal={showClearContentModal}
          primaryLanguage={languageTabs[0]}
        />
      </Question>
    )
  }
}

const enhance = compose(
  withRouter,
  withNamespaces('assessment'),
  connect(
    (state) => ({
      currentLanguage: getCurrentLanguage(state),
      languageTabs: getLanguageTabsSelector(state),
      questionData: getCurrentQuestionSelector(state),
    }),
    {
      setQuestionData: setQuestionDataAction,
    }
  )
)

export default enhance(TemplateMarkup)
